
import { images } from "../constants";

const courses = [
    {
        id: 1,
        image: images.course1,
        title: "AI Fundamentals",
        details: {
            date: "18 January, 2025", 
            duration: "3 Months",
            instructor: "Emily Carter",
            skillLevel: "Intermediate",
            certificate: "Yes",
            students: "100 Enrolled",
            price: "$100",
        },
        overviews: [
            "AI Fundamentals is designed to introduce students to the core concepts of artificial intelligence. This course covers machine learning, neural networks, and data preprocessing, providing hands-on experience in building AI models and applying AI techniques to real-world scenarios."
        ],
        features: [
            "Introduction to Machine Learning",
            "Understanding Neural Networks",
            "Data Preprocessing Techniques",
            "AI Algorithms Overview",
            "Hands-on AI Projects"
        ],
        outcomes: [
            "Understand the basics of AI and machine learning",
            "Build basic AI models and algorithms",
            "Analyze and preprocess data for AI applications",
            "Apply AI concepts to real-world problems",
            "Develop problem-solving skills in AI-driven tasks"
        ],
        prerequisites: [
            "Basic understanding of mathematics and statistics",
            "Familiarity with Python programming",
            "Interest in artificial intelligence and machine learning",
            "Willingness to engage in hands-on AI projects",
            "Commitment to learning and applying AI techniques"
        ],
        curriculum: [
            {
                id: 1,
                heading: "What is Artificial Intelligence?",
                content: "An introduction to AI, its history, and how it's shaping the future of technology."
            },
            {
                id: 2,
                heading: "How do Neural Networks work?",
                content: "Understanding the structure of neural networks and their applications in AI."
            },
            {
                id: 3,
                heading: "What are Data Preprocessing Techniques?",
                content: "Learn how to clean, process, and prepare data for machine learning models."
            },
            {
                id: 4,
                heading: "What are the key AI Algorithms?",
                content: "An overview of important AI algorithms such as supervised and unsupervised learning."
            },
            {
                id: 5,
                heading: "How to build an AI project?",
                content: "Hands-on training in building a real-world AI application."
            },
        ],
        reviews: [
            {
                id: 1,
                image: images.course1Comment1,
                name: "Michael Anderson",
                date: "November 5, 2024",
                rating: 5,
                content: "An excellent introduction to AI! The hands-on projects helped me grasp key concepts effectively."
            },
            {
                id: 2,
                image: images.course1Comment2,
                name: "Emily Johnson",
                date: "November 8, 2024",
                rating: 4.9,
                content: "Great course! The explanations were clear, and the instructor provided great insights into AI applications."
            }
        ],
    },
    {
        id: 2,
        image: images.course2,
        title: "Cloud Infrastructure Management",
        details: {
            date: "18 January, 2025", 
            duration: "4 Months",
            instructor: "Liam Anderson",
            skillLevel: "Intermediate",
            certificate: "Yes",
            students: "100 Enrolled",
            price: "$100",
        },
        overviews: [
            "Cloud Infrastructure Management is a comprehensive course designed to equip students with the skills needed to manage, deploy, and optimize cloud environments. This course covers cloud computing fundamentals, virtualization, security, and best practices for cloud resource management."
        ],
        features: [
            "Introduction to Cloud Computing",
            "Understanding Virtualization",
            "Cloud Security Best Practices",
            "Resource Management & Optimization",
            "Hands-on Cloud Deployment"
        ],
        outcomes: [
            "Understand cloud computing concepts and architectures",
            "Manage cloud resources effectively",
            "Implement security measures in cloud environments",
            "Optimize cloud infrastructure for performance and cost",
            "Gain hands-on experience with cloud platforms"
        ],
        prerequisites: [
            "Basic knowledge of networking and IT systems",
            "Familiarity with operating systems (Linux/Windows)",
            "Understanding of virtualization concepts",
            "Interest in cloud technology and infrastructure management",
            "Willingness to engage in practical cloud exercises"
        ],
        curriculum: [
            {
                id: 1,
                heading: "What is Cloud Computing?",
                content: "Introduction to cloud computing models, service types, and benefits."
            },
            {
                id: 2,
                heading: "How does Virtualization Work?",
                content: "Understanding virtualization technologies and their role in cloud environments."
            },
            {
                id: 3,
                heading: "What are Cloud Security Best Practices?",
                content: "Learning about cloud security threats and how to mitigate them."
            },
            {
                id: 4,
                heading: "How to Manage Cloud Resources?",
                content: "Techniques for optimizing cloud resources and reducing costs."
            },
            {
                id: 5,
                heading: "How to Deploy Applications in the Cloud?",
                content: "Hands-on training in deploying and managing applications in a cloud environment."
            },
        ],
        reviews: [
            {
                id: 1,
                image: images.course2Comment1,
                name: "Michael Anderson",
                date: "November 5, 2024",
                rating: 5,
                content: "An outstanding course! I learned a lot about managing cloud environments efficiently."
            },
            {
                id: 2,
                image: images.course2Comment2,
                name: "Emily Johnson",
                date: "November 8, 2024",
                rating: 4.9,
                content: "Great insights into cloud infrastructure. The hands-on exercises were really helpful!"
            }
        ],
    },
    {
        id: 3,
        image: images.course3,
        title: "Data Science and AI",
        details: {
            date: "18 January, 2025", 
            duration: "6 Months",
            instructor: "Michael Lee",
            skillLevel: "Intermediate",
            certificate: "Yes",
            students: "100 Enrolled",
            price: "$150",
        },
        overviews: [
            "Data Science and AI is a comprehensive course designed to provide students with a solid foundation in data analysis, machine learning, and artificial intelligence. Learn how to work with data, build AI models, and apply data-driven decision-making in real-world scenarios."
        ],
        features: [
            "Introduction to Data Science",
            "Exploratory Data Analysis (EDA)",
            "Machine Learning Fundamentals",
            "Deep Learning & Neural Networks",
            "Hands-on AI Projects"
        ],
        outcomes: [
            "Understand data science workflows and AI principles",
            "Perform data preprocessing and exploratory analysis",
            "Develop and evaluate machine learning models",
            "Apply AI techniques to real-world problems",
            "Gain hands-on experience with Python and AI libraries"
        ],
        prerequisites: [
            "Basic programming knowledge (preferably Python)",
            "Familiarity with mathematics and statistics",
            "Understanding of data structures and algorithms",
            "Interest in machine learning and AI applications",
            "Willingness to work on real-world AI projects"
        ],
        curriculum: [
            {
                id: 1,
                heading: "What is Data Science?",
                content: "Introduction to data science, its applications, and industry trends."
            },
            {
                id: 2,
                heading: "How to Clean and Prepare Data?",
                content: "Data preprocessing techniques, handling missing values, and feature engineering."
            },
            {
                id: 3,
                heading: "What is Machine Learning?",
                content: "Understanding supervised and unsupervised learning algorithms."
            },
            {
                id: 4,
                heading: "How to Build Neural Networks?",
                content: "Deep learning fundamentals, training neural networks, and model evaluation."
            },
            {
                id: 5,
                heading: "How to Apply AI in Real-World Problems?",
                content: "Developing AI-based solutions for industries like healthcare, finance, and automation."
            },
        ],
        reviews: [
            {
                id: 1,
                image: images.course3Comment1,
                name: "Michael Anderson",
                date: "November 5, 2024",
                rating: 5,
                content: "Fantastic course! The AI projects were hands-on and very insightful."
            },
            {
                id: 2,
                image: images.course3Comment1,
                name: "Emily Johnson",
                date: "November 8, 2024",
                rating: 4.9,
                content: "Great content and well-structured lessons. I feel confident in applying AI concepts now!"
            }
        ],
    },
    {
        id: 4,
        image: images.course4,
        title: "Startup Business Strategy",
        details: {
            date: "18 January, 2025", 
            duration: "3 Months",
            instructor: "Sophia Brown",
            skillLevel: "Beginner to Intermediate",
            certificate: "Yes",
            students: "100 Enrolled",
            price: "$120",
        },
        overviews: [
            "Startup Business Strategy is designed to equip aspiring entrepreneurs with the knowledge and tools to successfully launch and grow a business. Learn how to develop business models, secure funding, and implement growth strategies in a competitive market."
        ],
        features: [
            "Business Model Development",
            "Market Research and Competitive Analysis",
            "Funding and Investment Strategies",
            "Marketing and Branding Essentials",
            "Growth Hacking and Scaling Techniques"
        ],
        outcomes: [
            "Understand key startup fundamentals and business planning",
            "Develop a strong value proposition and competitive strategy",
            "Explore funding options and investor pitching techniques",
            "Create an effective marketing and branding strategy",
            "Learn practical growth and scaling techniques for startups"
        ],
        prerequisites: [
            "Passion for entrepreneurship and business",
            "Basic understanding of business concepts",
            "Interest in startup growth and strategy",
            "Willingness to work on business case studies",
            "Commitment to developing a startup idea"
        ],
        curriculum: [
            {
                id: 1,
                heading: "What Makes a Successful Startup?",
                content: "Understanding the key elements of a successful startup, including business models and innovation."
            },
            {
                id: 2,
                heading: "How to Conduct Market Research?",
                content: "Learning techniques for identifying target audiences and analyzing competitors."
            },
            {
                id: 3,
                heading: "How to Secure Funding?",
                content: "Exploring different funding sources such as venture capital, angel investors, and crowdfunding."
            },
            {
                id: 4,
                heading: "How to Build a Brand?",
                content: "Creating a compelling brand identity and developing a marketing strategy."
            },
            {
                id: 5,
                heading: "How to Scale a Startup?",
                content: "Strategies for scaling operations, automating processes, and managing growth effectively."
            },
        ],
        reviews: [
            {
                id: 1,
                image: images.course4Comment1,
                name: "Michael Anderson",
                date: "November 5, 2024",
                rating: 5,
                content: "This course provided a clear roadmap for launching a startup. Highly recommended!"
            },
            {
                id: 2,
                image: images.course4Comment1,
                name: "Emily Johnson",
                date: "November 8, 2024",
                rating: 4.9,
                content: "Great insights into startup strategy. The real-world examples were very helpful!"
            }
        ],
    },
    {
        id: 5,
        image: images.course5,
        title: "Artificial Intelligence for Entrepreneurs",
        details: {
            date: "18 January, 2025", 
            duration: "5 Months",
            instructor: "Emily Carter",
            skillLevel: "Beginner to Intermediate",
            certificate: "Yes",
            students: "120 Enrolled",
            price: "$150",
        },
        overviews: [
            "Artificial Intelligence for Entrepreneurs is designed for business owners and startup founders looking to leverage AI in their ventures. This course covers practical applications of AI in decision-making, automation, and business growth."
        ],
        features: [
            "Introduction to AI and its Business Applications",
            "AI-Powered Decision Making",
            "Automating Business Processes with AI",
            "AI in Marketing and Customer Engagement",
            "Future Trends and AI Ethics"
        ],
        outcomes: [
            "Understand how AI can optimize business operations",
            "Learn to integrate AI-driven automation in workflows",
            "Explore AI applications in marketing and customer experience",
            "Develop data-driven strategies for business growth",
            "Gain insights into ethical considerations and AI trends"
        ],
        prerequisites: [
            "Interest in AI applications for business",
            "Basic understanding of business operations",
            "Willingness to explore AI-driven tools and strategies",
            "No prior technical AI knowledge required",
            "Curiosity to experiment with AI in entrepreneurship"
        ],
        curriculum: [
            {
                id: 1,
                heading: "How Can AI Benefit Entrepreneurs?",
                content: "Exploring the key benefits of AI, including automation, efficiency, and data-driven decision-making."
            },
            {
                id: 2,
                heading: "How to Implement AI in Business?",
                content: "Learning the tools and platforms that enable AI-driven business automation."
            },
            {
                id: 3,
                heading: "How AI Transforms Marketing?",
                content: "Understanding AI-driven customer insights, personalized marketing, and chatbots."
            },
            {
                id: 4,
                heading: "How to Use AI for Growth?",
                content: "Utilizing AI for business scaling, operational efficiency, and competitive advantage."
            },
            {
                id: 5,
                heading: "What Are the Ethical Concerns?",
                content: "Examining ethical considerations, data privacy, and responsible AI use."
            },
        ],
        reviews: [
            {
                id: 1,
                image: images.course5Comment1,
                name: "Michael Anderson",
                date: "November 5, 2024",
                rating: 5,
                content: "This course provided valuable insights into AI for startups. A must for entrepreneurs!"
            },
            {
                id: 2,
                image: images.course5Comment1,
                name: "Emily Johnson",
                date: "November 8, 2024",
                rating: 4.8,
                content: "Great introduction to AI for business. The practical applications were very useful!"
            }
        ],
    },
    {
        id: 6,
        image: images.course6,
        title: "Tech Innovations in IT Startups",
        details: {
            date: "18 January, 2025", 
            duration: "4 Months",
            instructor: "Sophia Brown",
            skillLevel: "Intermediate",
            certificate: "Yes",
            students: "90 Enrolled",
            price: "$130",
        },
        overviews: [
            "Tech Innovations in IT Startups is designed for aspiring entrepreneurs and startup founders looking to harness cutting-edge technology. This course covers emerging trends, scalable tech solutions, and innovation strategies for IT startups."
        ],
        features: [
            "Introduction to Emerging Tech Trends",
            "Cloud Computing and Scalable Infrastructure",
            "AI and Machine Learning in Startups",
            "Blockchain for Secure Transactions",
            "Building a Tech-Driven Business Model"
        ],
        outcomes: [
            "Understand the latest technology trends shaping IT startups",
            "Learn to implement AI, blockchain, and cloud solutions",
            "Develop a scalable and secure IT infrastructure",
            "Gain insights into funding and investor attraction",
            "Build a technology-driven competitive advantage"
        ],
        prerequisites: [
            "Basic understanding of IT and business models",
            "Interest in startup technology innovations",
            "Willingness to explore emerging digital solutions",
            "No prior coding experience required",
            "Entrepreneurial mindset and passion for tech"
        ],
        curriculum: [
            {
                id: 1,
                heading: "What Are the Latest IT Trends?",
                content: "Exploring AI, blockchain, and cloud innovations shaping the startup landscape."
            },
            {
                id: 2,
                heading: "How to Build Scalable Tech Infrastructure?",
                content: "Understanding cloud computing, data security, and scalability for startups."
            },
            {
                id: 3,
                heading: "How Can AI and ML Help Startups?",
                content: "Leveraging artificial intelligence for automation, analytics, and business intelligence."
            },
            {
                id: 4,
                heading: "What Role Does Blockchain Play?",
                content: "Exploring the use of blockchain in securing transactions and decentralization."
            },
            {
                id: 5,
                heading: "How to Secure Funding for Tech Startups?",
                content: "Understanding venture capital, investor expectations, and funding strategies."
            },
        ],
        reviews: [
            {
                id: 1,
                image: images.course6Comment1,
                name: "Sophia Martinez",
                date: "November 10, 2024",
                rating: 5,
                content: "A fantastic course with real-world applications! Helped me refine my startup’s tech strategy."
            },
            {
                id: 2,
                image: images.course6Comment1,
                name: "Daniel Foster",
                date: "November 15, 2024",
                rating: 4.7,
                content: "Highly informative! Gained valuable insights into using AI and cloud tech for startups."
            }
        ],
    }

];

export default courses;